module.exports = __webpack_public_path__ + "media/alarm.28ab7cb6.mp3";